import React from 'react';

import { Box, Center, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { useGetAndLogUserErrorMessage } from 'hooks/log-user-error-message';
import { CreateCaseState } from 'state/knowledge-force/types';
import { theme } from 'styles/configure-theme';

import { ICreateSupportCaseFeedbackProps } from './types';

export const CreateSupportCaseFeedback = ({
  createCaseState,
  createCaseErrorMessage: createCaseErrorMessageProp,
}: ICreateSupportCaseFeedbackProps) => {
  const { formatMessage } = useIntl();
  const createCaseErrorMessage =
    createCaseErrorMessageProp || formatMessage({ id: 'errorCreatingSupportCase' });

  const getErrorMessage = useGetAndLogUserErrorMessage({ message: createCaseErrorMessage });

  const createCaseStateSuccessMessage = (
    <Box px="$6" pb="$2" _android={{ px: '$4' }}>
      <Box>{formatMessage({ id: 'successfullyCreatedSupportCase' })}</Box>
      <Box>{formatMessage({ id: 'waitForReply' })}</Box>
    </Box>
  );

  const isCreateCaseStateSuccess = createCaseState === CreateCaseState.SUCCESS;
  const isCreateCaseStateError = createCaseState === CreateCaseState.ERROR;
  return (
    <Center mb="$6" testID="after-submission-message">
      {isCreateCaseStateError && (
        <Text ml="$4" mr="$4" variant="copyOne" color={theme.token('text-error')}>
          {getErrorMessage()}
        </Text>
      )}
      {isCreateCaseStateSuccess && createCaseStateSuccessMessage}
    </Center>
  );
};
